;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { personalizedResource } from '@/lib/resources/personalized-resource';

// types
import type { ShowDetails, ShowRowContent } from '@/lib/types/api/show-data'

export const myListShows = personalizedResource<ShowRowContent | ShowDetails>({
  key: 'myListShows',
  endpoint: '/api/profile/my-list-shows/',
  select: (json) => (json as { myListShowsData: (ShowRowContent | ShowDetails)[] | null }).myListShowsData,
})
